<template>
  <div>
    <h1>{{ profile ? "編輯" : "新增" }}聯絡人</h1>
    <el-form ref="form" :model="form">
      <el-form-item label="名稱" prop="name">
        <el-input v-model="form.name" autocomplete="off" />
      </el-form-item>
      <el-form-item label="備註" prop="name">
        <el-input v-model="form.description" autocomplete="off" />
      </el-form-item>
      <el-form-item label="地址" prop="name">
        <el-input v-model="form.address" autocomplete="off" />
      </el-form-item>

      <el-form-item label="電話" prop="name">
        <el-input v-model="form.phone" autocomplete="off" />
      </el-form-item>
      <el-form-item label="email" prop="name">
        <el-input v-model="form.email" autocomplete="off" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="update">{{
          profile ? "儲存" : "新增"
        }}</el-button>
        <el-button
          v-if="profile"
          type="danger"
          @click="handleDelete"
        >刪除</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { createProfile, updateProfile, deleteProfile } from '@/api/profile'
export default {
  props: ['profile_id', 'profile_type', 'profile'],
  data() {
    return {
      form: {
        name: '',
        description: '',
        address: '',
        phone: '',
        email: '',
        profile_id: this.profile_id,
        profile_type: 'company'
      }
    }
  },
  created() {
    if (this.profile) {
      this.form = this.profile
    }
  },
  methods: {
    async update() {
      if (this.profile) {
        const data = await updateProfile(this.profile.id, this.form)
      } else {
        const data = await createProfile(this.form)
      }
      this.$emit('onUpdate')
    },
    async handleDelete() {
      await deleteProfile(this.profile.id)
      this.$emit('onUpdate')
    }
  }
}
</script>
